<template>
  <!-- App panel -->
  <data-loader />

  <div class="relative h-auto md:h-full w-full lg:absolute lg:inset-0 lg:z-0 p-4">
    <!--
      data-app-scroll: to jest FAKTYCZNY kontener przewijania aplikacji.
      Okno się nie przewija — BasicLayout to `h-screen`, a jego środek `overflow-hidden`,
      więc window.scrollY zawsze wynosi 0. Znacznik pozwala routerowi (scrollBehavior)
      trafić w ten element zamiast bezskutecznie wołać window.scrollTo.
    -->
    <div data-app-scroll class="h-full w-full overflow-auto">
      <!--
        data-page-top: początek zawartości panelu, PONAD filtrami.
        Alternatywny cel przewijania przy paginacji — patrz PAGINATION_SCROLL_TARGET
        w @/router/index. Pusty znacznik o zerowej wysokości, poza flexem
        (rodzic nie jest flexem, więc nie dokłada gapa).
      -->
      <div data-page-top></div>
      <div class="h-auto md:h-full flex flex-col gap-4">
        <div class="flex-none md:h-full w-auto">
          <!-- App panel slot -->
          <slot />
          <!-- End of App panel slot -->
        </div>
      </div>
    </div>
  </div>
  <!-- End of App panel -->
  <!-- <div
    class="relative overflow-y-auto bg-surface-0 dark:bg-surface-900 text-surface-700 dark:text-surface-0/80"
  >
    <slot />
    <data-loader />
  </div> -->
</template>
